"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectGift = exports.initialState = exports.giftSlice = exports.fetchVerifyGift = exports.fetchUpdateGift = exports.fetchRedeemGift = exports.fetchGift = exports.default = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _api = require("../api");
const initialState = exports.initialState = {
  gift: {},
  verifiedGift: {},
  loading: false,
  error: null,
  isUpdateLoading: false,
  isVerifyLoading: false,
  isRedeemLoading: false
};
const fetchGift = exports.fetchGift = (0, _toolkit.createAsyncThunk)('gift/fetchGift', async (giftId, _ref) => {
  let {
    rejectWithValue
  } = _ref;
  try {
    const result = await (0, _api.getGift)(giftId);
    return result;
  } catch (err) {
    const typedError = err;
    return rejectWithValue(typedError.message);
  }
});
const fetchUpdateGift = exports.fetchUpdateGift = (0, _toolkit.createAsyncThunk)('gift/updateGift', async (_ref2, _ref3) => {
  let {
    id,
    payload
  } = _ref2;
  let {
    rejectWithValue
  } = _ref3;
  try {
    const result = await (0, _api.updateGift)(id, payload);
    return result;
  } catch (err) {
    const typedError = err;
    return rejectWithValue(typedError.message);
  }
});
const fetchVerifyGift = exports.fetchVerifyGift = (0, _toolkit.createAsyncThunk)('gift/verifyGift', async (giftCode, _ref4) => {
  let {
    rejectWithValue
  } = _ref4;
  try {
    const result = await (0, _api.verifyGift)(giftCode);
    return result;
  } catch (err) {
    const typedError = err;
    return rejectWithValue(typedError.message);
  }
});
const fetchRedeemGift = exports.fetchRedeemGift = (0, _toolkit.createAsyncThunk)('gift/redeemGift', async (giftCode, _ref5) => {
  let {
    rejectWithValue
  } = _ref5;
  try {
    const result = await (0, _api.redeemGift)(giftCode);
    return result;
  } catch (err) {
    const typedError = err;
    return rejectWithValue(typedError.message);
  }
});
const giftSlice = exports.giftSlice = (0, _toolkit.createSlice)({
  name: 'gift',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchGift.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchGift.fulfilled, (state, action) => {
      state.loading = false;
      state.gift = action.payload;
    });
    builder.addCase(fetchGift.rejected, (state, action) => {
      state.loading = false;
      if (action.payload) {
        state.error = action.payload;
      }
    });
    builder.addCase(fetchUpdateGift.pending, state => {
      state.isUpdateLoading = true;
    });
    builder.addCase(fetchUpdateGift.fulfilled, (state, action) => {
      state.isUpdateLoading = false;
      state.gift = action.payload;
    });
    builder.addCase(fetchUpdateGift.rejected, (state, action) => {
      state.isUpdateLoading = false;
      if (action.payload) {
        state.error = action.payload;
      }
    });
    builder.addCase(fetchVerifyGift.pending, state => {
      state.isVerifyLoading = true;
    });
    builder.addCase(fetchVerifyGift.fulfilled, (state, action) => {
      state.isVerifyLoading = false;
      state.error = '';
      state.verifiedGift = action.payload;
    });
    builder.addCase(fetchVerifyGift.rejected, (state, action) => {
      state.isVerifyLoading = false;
      state.verifiedGift = {};
      if (action.payload) {
        state.error = 'Provided gift code is invalid. Please provide a valid code and try again.';
      }
    });
    builder.addCase(fetchRedeemGift.pending, state => {
      state.isRedeemLoading = true;
    });
    builder.addCase(fetchRedeemGift.fulfilled, state => {
      state.isRedeemLoading = false;
    });
    builder.addCase(fetchRedeemGift.rejected, (state, action) => {
      state.isRedeemLoading = false;
      if (action.payload) {
        state.error = action.payload;
      }
    });
  }
});
const selectGift = state => state.gift;
exports.selectGift = selectGift;
var _default = exports.default = giftSlice.reducer;